import { createAsyncThunk } from '@reduxjs/toolkit';
import formFieldAPI from '@infrastructure/form-field-api';
import { getErrorPayload } from '@application/helpers/api-helper';
export const createFormFieldAsync = createAsyncThunk('formField/create', async (formFieldRequest, { rejectWithValue }) => {
    try {
        const response = await formFieldAPI.createFormField(formFieldRequest);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateFormFieldAsync = createAsyncThunk('formField/update', async (formField, { rejectWithValue }) => {
    try {
        const response = await formFieldAPI.updateFormField(formField);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteFormFieldAsync = createAsyncThunk('formField/delete', async (id, { rejectWithValue }) => {
    try {
        const response = await formFieldAPI.deleteFormField(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFormFieldByIdAsync = createAsyncThunk('formField/getFormFieldById', async (id, { rejectWithValue }) => {
    try {
        const response = await formFieldAPI.getFormFieldById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFormFieldsByFormStepIdAsync = createAsyncThunk('formField/getFormFieldsByFormStepId', async (formStepId, { rejectWithValue }) => {
    try {
        const response = await formFieldAPI.getFormFieldsByFormStepId(formStepId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getIdentityFormFieldsByEventIdAsync = createAsyncThunk('formField/getIdentityFormFieldsByEventId', async (request, { rejectWithValue }) => {
    try {
        const response = await formFieldAPI.getIdentityFormFieldsByEventId(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
